import { ContactUsWidgetService } from '@anecdotes/support';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { InitAction } from '../../actions';

@Injectable()
export class ChatInitEffects {
  constructor(
    private actions$: Actions,
    private contactUsWidgetService: ContactUsWidgetService,
  ) {}

  initChat$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(InitAction),
        // *** TEMPORARY TURNED OFF ***
        // switchMap(() => this.contactUsWidgetService.initAsync()),
      ),
    { dispatch: false },
  );
}
